import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class NotificationManager  {
    _originalTypeClassName = "ekylikeio.BO.NotificationManager";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
NotificationManager.translate = translateService;
}
this.NotificationManagerKey = null;
this._key = this.NotificationManagerKey = 0; 
}

static translate: TranslateService;
_key: any;
private _NotificationManagerKey:any;
get NotificationManagerKey(): any {
    return this._NotificationManagerKey;
  }
set NotificationManagerKey(value: any) {
    this._NotificationManagerKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.NotificationManagerKey == null || $this.NotificationManagerKey == 0;
            }


}